import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  className?: string;
}

const EmptyState: FC<Props> = ({ className }) => {
  return (
    <Root className={className}>
      <Typography variant="subtitle1">
        <FormattedMessage id="latest_insights_list.empty_message" />
      </Typography>
    </Root>
  );
};

const Root = styled('div')({ textAlign: 'center' });

export default EmptyState;
